module.exports = __webpack_public_path__ + "img/home_bnaner1.14ab407c.jpg";